import { backgroundStyles, borderStyles } from 'styles/theme';
import { CSSProperties } from 'react';
import styled from '@emotion/styled';

const lastChild = 'last-child';
const firstChild = 'first-child';

const borderStyle = `1px solid ${borderStyles.colors.primary}`;

export const TableContainer = styled.div({
  // border: `1px solid ${borderStyles.colors.primary}`,
  // borderRadius: 6,
  overflow: 'auto',
  padding: '0 24px',
});

export const Table = styled.table({
  width: '100%',
  height: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
  // border: `1px solid ${borderStyles.colors.primary}`,
});

export const TableHeaderRow = styled.tr({
  [`th:${firstChild}`]: {
    borderTopLeftRadius: '12px',
    borderRight: 'none',
  },
  [`th:${lastChild}`]: {
    borderTopRightRadius: '12px',
    borderLeft: 'none',
  },
});

export const TableHeaderCell = styled.th({
  border: borderStyle,
  borderBottom: borderStyle,
  textAlign: 'left',
  padding: '12px',
  backgroundColor: backgroundStyles.colors.quaternary,
});

export const TableBody = styled.tbody({
  [`tr:${lastChild}`]: {
    [`td:${firstChild}`]: {
      borderBottomLeftRadius: '12px',
    },
    [`td:${lastChild}`]: {
      borderBottomRightRadius: '12px',
    },
  },
});

export const TableBodyRow = styled.tr({
  td: {
    borderLeft: borderStyle,
    borderRight: borderStyle,
    borderBottom: borderStyle,
  },
  [`td:${firstChild}`]: {
    borderRight: 'none',
  },
  [`td:${lastChild}`]: { borderLeft: 'none' },
});

type TableCellProps = {
  textAlign?: CSSProperties['textAlign'];
};
export const TableCell = styled.td((props: TableCellProps) => ({
  padding: '12px',
  alignContent: 'flex-start',
  textAlign: props.textAlign,
}));
